module.exports = __webpack_public_path__ + "static/img/one.31a665f3.svg";